import type { ArtWork } from "@/mocks/narutoContent";

export default function ArtCard({ work }: { work: ArtWork }) {
  const isPortrait = work.type === "同人插画";
  return (
    <article className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
      <div className={`relative overflow-hidden ${isPortrait ? "aspect-[4/5]" : "aspect-[16/9]"}`}>
        <img
          src={work.cover}
          alt={`${work.title} 火影忍者同人${work.type}`}
          title={`${work.title} · 火影忍者同人图`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
        <div className="absolute inset-x-0 bottom-0 translate-y-2 p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <h3 className="font-display text-lg text-background-50">{work.title}</h3>
          <p className="mt-1 font-label text-xs text-background-200">by {work.artist} · {work.tag}</p>
        </div>
        <button
          type="button"
          className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full bg-background-50/90 text-primary-700 opacity-0 transition-opacity duration-300 group-hover:opacity-100 hover:bg-primary-500 hover:text-background-50"
          aria-label={`收藏 ${work.title}`}
          title="收藏"
        >
          <i className="ri-heart-line"></i>
        </button>
      </div>
      <div className="flex items-center justify-between px-4 py-3">
        <span className="inline-flex items-center gap-1.5 font-label text-xs text-foreground-600">
          <span className={`rounded-full px-2 py-0.5 ${work.type === "高清壁纸" ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-700"}`}>
            {work.type}
          </span>
        </span>
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-1 font-label text-xs text-foreground-500"><i className="ri-eye-line"></i>{work.views}</span>
          {work.type === "高清壁纸" && (
            <button
              type="button"
              className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs text-secondary-800 transition-colors hover:bg-primary-500 hover:text-background-50"
              aria-label={`下载 ${work.title}`}
              title="下载"
            >
              <i className="ri-download-2-line"></i> 下载
            </button>
          )}
        </div>
      </div>
    </article>
  );
}